module.exports = __webpack_public_path__ + "img/logo.8b84efd4.png";